import React from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./styles.scss";
import { ChevronUp } from "../../assets/svgs";

const UploadDocSuccessCard = ({ title, description, documentName }) => {
  const location = useLocation();
  const { pathname } = location;
  const routeName = pathname.split("/")[1];
  const { t } = useTranslation();
  return (
    <div className="upload-card">
      <div className="upload-row-header">
        <div className="upload-header-title">{title}</div>
        <img src={ChevronUp} alt="upload-icon" className="upload-icon-small" />
      </div>
      <p className="description">{description}</p>
      <label htmlFor="upload-input" className="upload-action">
        {documentName}
      </label>
    </div>
  );
};

export default UploadDocSuccessCard;
